module.exports = __webpack_public_path__ + "static/hero-about.e42aba3a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hero-about.jpeg
// module id = 466
// module chunks = 59330042967093